/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
import Vue from 'vue'

const state = {
  empresa: {

  },
  filtrarDocsModelo: false,
  filtrarDocsContato: false,
  ultimoDocumentoAtualizado: null,
  documentosAlterados: [],
}

// getters
const getters = {
  empresa: state_ => state_.empresa,
  empresaToSave: state_ => {
    const emp = state_.empresa
    emp.ieItens = !emp.ieItens || emp.ieItens.length === 0 ? [] : state_.empresa.ieItens.filter(f => !!f.ie)
    emp.imItens = !emp.imItens || emp.imItens.length === 0 ? [] : state_.empresa.imItens.filter(f => !!f.im)
    emp.cnaeSecundarios = !emp.cnaeSecundarios || emp.cnaeSecundarios.length === 0
      ? emp.cnaeSecundarios
      : state_.empresa.cnaeSecundarios.filter(f => !!f.idIBGE)
    emp.cnaePrincipal = !emp.cnaePrincipal || !emp.cnaePrincipal.idIBGE ? null : state_.empresa.cnaePrincipal
    emp.departamentos = !emp.departamentos || emp.departamentos.length === 0
      ? emp.departamentos
      : state_.empresa.departamentos.filter(f => !!f.departamento)
    emp.contatos = !emp.contatos || emp.contatos.length === 0
      ? emp.contatos
      : state_.empresa.contatos.filter(f => !!f.usuario)
    return emp
  },
  ieItens: state_ => (!state_.empresa ? null : state_.empresa.ieItens),
  imItens: state_ => (!state_.empresa ? null : state_.empresa.imItens),
  cnaePrincipal: state_ => (!state_.empresa ? null : state_.empresa.cnaePrincipal || {}),
  cnaeSecundarios: state_ => (!state_.empresa ? null : state_.empresa.cnaeSecundarios || []),
  endereco: state_ => state_.empresa.endereco,
  departamentos: state_ => (!state_.empresa ? null : state_.empresa.departamentos),
  contatos: state_ => (!state_.empresa ? null : state_.empresa.contatos),
  // METODOS PARA MANIPULACAO DOS DOCUMENTOS
  empresaDocumentos: state_ => state_.empresa.empresaDocumentos,
  /**
   * @param {*} state_
   * @returns Retorna os documentos selecionados de cada departamento
   */
  documentosSelecionados: state_ => state_.empresa.empresaDocumentos,
  /**
   *
   * @param {*} state_
   * @param {Number} indexDepart Indice do departamento que contém os documentos
   * @returns retorna os documentos do departamento do índice passado por parâmetro
   */
  getDocumentosDeDepartamentoIndex: state_ => indexDepart => state_.empresa.empresaDocumentos[indexDepart].documentos,
  /**
   *
   * @param {*} state_
   * @param {Number} departamento Departamento que contém os documentos
   * @returns retorna os documentos do departamento passado por parâmetro
   */
  getDocumentosDeDepartamento: state_ => departamento => {
    const { empresaDocumentos } = state_.empresa
    const index = empresaDocumentos.findIndex(f => f.departamento.id === departamento.id)
    return empresaDocumentos[index].documentos
  },
  /**
   * Obtém o documento da empresa atual, utilizado ou o identificador, quando já salvo, ou o código temporário caso
   * ainda não tenha sido salvo
   * @param {*} state_
   * @returns retorna o documento da empresa
   */
  getEmpresaDocumento: state_ => (indexDepart, empresaDocumento) => {
    const empDocumentos = state_.empresa.empresaDocumentos[indexDepart].documentos
    return empDocumentos.find(f => (empresaDocumento.id && f.id === empresaDocumento.id)
      || (empresaDocumento.code && f.code === empresaDocumento.code))
  },
  /**
   *
   * @param {*} state_
   * @param {Object} departamento Departamento que se deseja saber o indice
   * @returns retorna o indice do departamento desejado
   */
  getDepartamentoIndex: state_ => departamento => state_.empresa.empresaDocumentos.findIndex(f => f.departamento.id === departamento.id),
  filtrarDocsModelo: state_ => state_.filtrarDocsModelo,
  filtrarDocsContato: state_ => state_.filtrarDocsContato,
  getCopiaEmpresaDocumentos: state_ => (contato, departamentos) => {
    const contatoDocumentos = []
    const contatoAtual = state_.empresa.contatos.find(f => (contato.id && contato.id === f.id) || (contato.code && contato.code === f.code))

    if (contatoAtual) { // && (contatoAtual.documentos.length === 0 || contatoAtual.documentos.findIndex(f => f.departamento && (f.departamento.id === departamento.id)) < 0)
      for (let j = 0; j < departamentos.length; j += 1) {
        const departamento = departamentos[j]

        // Obteve os documentos de determinado departamento
        let empresaDocumentos = state_.empresa.empresaDocumentos.find(f => f.departamento.id === departamento.id)
        if (!empresaDocumentos) {
          // eslint-disable-next-line no-continue
          continue
        }

        empresaDocumentos = empresaDocumentos.documentos

        // Caso não exista o departamento ainda
        const contatoDocumento = {
          departamento,
          documentos: [],
        }
        for (let i = 0; i < empresaDocumentos.length; i += 1) {
          const documento = { ...empresaDocumentos[i] }
          documento.empresaDocumentoId = documento.id
          documento.empresaDocumentoCode = documento.code
          documento.id = 0
          documento.code = Date.now().toString(36) + Math.random().toString(36).substring(2)
          contatoDocumento.documentos.push(documento)
        }
        contatoDocumentos.push(contatoDocumento)
      }
    }
    return contatoDocumentos
  },
  getDepartamentosContatos: state_ => departamento => {
    const { contatos } = state_.empresa
    return contatos.filter(f => f.departamento.id === departamento.id)
  },
}

// ACTIONS
const actions = {
  setEmpresa({ commit, getters }, empresa) {
    commit('SET_EMPRESA', empresa)
    if (!getters.empresa.anexoEmpresa) {
      commit('INICIALIZA_ANEXOS')
    }
    if (getters.empresa.contatos.length === 0) {
      commit('ADD_CONTATO')
    }
  },
  setDadosAlterados({ commit }, empresa) {
    commit('SET_DADOS_ALTERADOS', empresa)
  },
  inicializaEmpresa({ commit, getters }) {
    commit('INICIALIZA')
    if (getters.empresa.contatos.length === 0) {
      commit('ADD_CONTATO')
    }
  },
  setEmpresaDocumentos({ state, commit, dispatch }, { empresaDocumentos, veioDoModelo = false, replicado = false }) {
    let propagar = true // antes estava como false, mas na primeira vez que realizava a inclusão do modelo não estava propagando para os contatos!
    if (veioDoModelo
      && (state.empresa.empresaDocumentos != null && state.empresa.empresaDocumentos.length > 0)) {
      commit('REMOVER_DOCUMENTOS_MODELOS_ANTIGOS')
      propagar = true
    }

    commit('SET_EMPRESA_DOCUMENTOS', {
      empresaDocumentos,
      veioDoModelo,
      concatenar: true,
      replicado,
    })

    if (propagar) {
      for (let i = 0; i < state.empresa.empresaDocumentos.length; i += 1) {
        const porDepartamento = state.empresa.empresaDocumentos[i]
        for (let j = 0; j < porDepartamento.documentos.length; j += 1) {
          const doc = porDepartamento.documentos[j]
          dispatch('propagarParaContatos', {
            departamento: porDepartamento.departamento,
            documento: doc,
            selecionado: true,
          })
        }
      }
    }
  },
  adicionarDocumentoCustom({ commit, dispatch, getters }, {
    indexDepart, departamento, empresaDocumento, copia,
  }) {
    let empresaDocumentos = null
    if (indexDepart >= 0) {
      empresaDocumentos = getters.getDocumentosDeDepartamentoIndex(indexDepart)
    } else {
      const index = getters.getDepartamentoIndex(departamento)
      if (index < 0) {
        commit('ADD_DEPARTAMENTO', departamento)
        empresaDocumentos = getters.getDocumentosDeDepartamento(departamento)
      } else {
        empresaDocumentos = getters.getDocumentosDeDepartamentoIndex(index)
      }
    }

    commit('ADD_DOCUMENTO', { empresaDocumentos, empresaDocumento, copia })
    dispatch('adicionarDocumentoContatos', { departamento, empresaDocumento })
  },
  removerDocumentoCustom({ commit, getters, dispatch }, { indexDepart, departamento, empresaDocumento }) {
    commit('REMOVE_DOCUMENTO', { empresaDocumentos: getters.getDocumentosDeDepartamentoIndex(indexDepart), empresaDocumento })
    dispatch('propagarParaContatos', {
      departamento, documento: empresaDocumento, selecionado: false,
    })
  },
  adicionarTagDocumento({ commit, getters }, { indexDepart, empresaDocumento, tag }) {
    commit('ADD_TAG_DOCUMENTO', { empresaDocumento: getters.getEmpresaDocumento(indexDepart, empresaDocumento), tag })
    commit('SET_FILTRAR_DOCS_MODELO', true)
  },
  editarTagDocumento({ commit, getters }, { indexDepart, empresaDocumento, tag }) {
    commit('EDITAR_TAG_DOCUMENTO', { empresaDocumento: getters.getEmpresaDocumento(indexDepart, empresaDocumento), tag })
  },
  removerTagDocumento({ commit, getters }, { indexDepart, empresaDocumento, tag }) {
    const empDoc = getters.getEmpresaDocumento(indexDepart, empresaDocumento)
    commit('REMOVE_TAG_DOCUMENTO', { empresaDocumento: empDoc, tag })
  },
  adiconarTagDocumentoMultiplaCobranca({ commit, getters }, { indexDepart, empresaDocumento }) {
    commit('ADD_TAG_DOCUMENTO_COBRANCA_MULTIPLA', { empresaDocumento: getters.getEmpresaDocumento(indexDepart, empresaDocumento) })
  },
  propagarParaContatos({ state, commit }, { departamento, documento, selecionado }) {
    state.ultimoDocumentoAtualizado = documento
    if (selecionado) {
      commit('ADICIONA_DOCUMENTO_CONTATOS', { departamento, customizado: false, removidoDaEmpresa: true })
    } else {
      commit('REMOVER_DOCUMENTO_CONTATOS', { departamento, customizado: false, removidoDaEmpresa: true })
    }
  },
  selecionarTodos({
    state, getters, commit, dispatch,
  }, { departamento, selecionado }) {
    const departamentoIndex = getters.getDepartamentoIndex(departamento)
    commit('SELECIONAR_TODOS_DOCS_EMPRESA', { departamentoIndex, documentosEmpresa: getters.getDocumentosDeDepartamento(departamento), selecionado })
    for (let i = 0; i < state.documentosAlterados.length; i += 1) {
      const doc = state.documentosAlterados[i]
      dispatch('propagarParaContatos', { departamento, documento: doc, selecionado })
    }
    state.documentosAlterados = []
  },
  adicionarContato({ commit }) {
    commit('ADD_CONTATO')
  },
  adicionarDocumentoContatos({ commit }, { departamento, empresaDocumento }) {
    commit('ADICIONA_DOCUMENTO_CONTATOS', { departamento, empresaDocumento, customizado: true })
  },
  adicionaResponsaveisDepartamento({ commit }) {
    commit('ADD_RESPONSAVEIS_DEPARTAMENTO')
  },
  setDadosInativacao({ commit }, { motivo, observacao }) {
    commit('SET_DADOS_INATIVAR', { motivo, observacao })
  },
}

// mutations
const mutations = {
  INICIALIZA(state_) {
    Vue.set(state_, 'empresa', {
      nome: null,
      descricao: null,
      tipoInscricao: 'CNPJ',
      cadastroFederal: '',
      razaoSocial: '',
      nomeFantasia: '',
      tipoAtividade: null,
      matrizFilial: 'Matriz',
      clienteFixo: true,
      clienteDesde: '',
      inicioAtividade: '',
      grupoEmpresarial: null,
      cnaePrincipal: {},
      cnaeSecundarios: [],
      ieItens: [],
      imItens: [],
      modelo: null,
      empresaDocumentos: [],
      endereco: {
        telefoneContato: {
          telefoneWhatsApp: false,
          celularWhatsApp: false,
        },
      },
      departamentos: [],
      contatos: [],
      pessoas: [],
      capitalSocial: 0,
      competenciaBaseHonorarios: null,
      anexoEmpresa: {},
      idOMIE: null,
      historico: {},
      motivoAtivaInativacao: '',
      observarAtivarInativar: '',
    })
  },
  INICIALIZA_ANEXOS(state_) {
    Vue.set(state_.empresa, 'anexoEmpresa', {})
    Vue.set(state_.empresa, 'clienteFixo', true)
  },
  SET_EMPRESA(state_, empresa) {
    Vue.set(state_, 'empresa', empresa)
  },
  SET_DADOS_ALTERADOS(state_, empresa) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in empresa) {
      if (state_.empresa[key] || state_.empresa[key] === '' || !state_.empresa[key]) {
        state_.empresa[key] = empresa[key]
      }
    }
  },
  SET_EMPRESA_DOCUMENTOS(state_, {
    empresaDocumentos, veioDoModelo = false, concatenar = false, replicado = false,
  }) {
    empresaDocumentos.forEach(documentosPorDepartamento => {
      documentosPorDepartamento.documentos.forEach(doc => {
        doc.code = Date.now().toString(36) + Math.random().toString(36).substring(2)
        if (!replicado) {
          doc.vgtSelected = true
          doc.selecionado = true
          if (veioDoModelo) {
            doc.documentoId = doc.id
            doc.id = 0
            doc.selecionado = true
          }
        }
      })
    })

    if (concatenar && !replicado && state_.empresa.empresaDocumentos.length > 0) {
      const departIguais = []
      state_.empresa.empresaDocumentos.forEach(porDepartamento => {
        const doNovo = empresaDocumentos.find(f => f.departamento.id === porDepartamento.departamento.id)
        if (doNovo) {
          porDepartamento.documentos = porDepartamento.documentos.concat([...doNovo.documentos])
          departIguais.push(porDepartamento.departamento.id)
        }
      })
      // Significa que vieram departamentos novos, que não existiam antes
      if (!departIguais || departIguais.length !== empresaDocumentos.length) {
        state_.empresa.empresaDocumentos = state_.empresa.empresaDocumentos
          .concat([...empresaDocumentos.filter(f => !(departIguais.includes(f.departamento.id)))])
      }
    } else {
      state_.empresa.empresaDocumentos = empresaDocumentos
    }
  },
  REMOVER_DOCUMENTOS_MODELOS_ANTIGOS(state_) {
    // Alterarndo os documentos da empresa para inativo e customizaado caso exista cobrança
    state_.empresa.empresaDocumentos = state_.empresa.empresaDocumentos.filter(fPorDocumento => {
      const filtrados = fPorDocumento.documentos.filter(f => {
        if (f.id > 0 && f.hasCobranca) {
          f.ativo = false
          f.customizado = true
          f.selecionado = false
          f.vgtSelected = false
          return true
        }
        return false
      })

      if (filtrados.length === 0) {
        return false
      }
      Vue.set(fPorDocumento, 'documentos', filtrados)
      return true
    })

    // Alterarndo os documentos de cada contato para inativo e customizaado caso exista cobrança
    for (let j = 0; j < state_.empresa.contatos.length; j += 1) {
      if (state_.empresa.contatos[j].documentos && state_.empresa.contatos[j].documentos.length > 0) {
        state_.empresa.contatos[j].documentos = state_.empresa.contatos[j].documentos
          .filter(fContatos => {
            const docsFiltrados = fContatos.documentos
              .filter(f => {
                if (f.id > 0 && f.hasCobranca) {
                  f.ativo = false
                  f.customizado = true
                  f.selecionado = false
                  f.vgtSelected = false
                  return true
                }
                return false
              })

            if (docsFiltrados.length === 0) {
              return false
            }
            Vue.set(state_.empresa.contatos[j], 'documentos', docsFiltrados)
            return true
          })
      }
    }
  },
  ADD_DEPARTAMENTO(state_, departamento) {
    const novoDepart = JSON.parse(JSON.stringify(departamento))
    Vue.set(state_.empresa.empresaDocumentos, state_.empresa.empresaDocumentos.length, {
      departamento: novoDepart, documentos: [],
    })
  },
  // MANIPULACAO DOS DOCUMENTOS NO MODELOS
  ADD_DOCUMENTO(state_, { empresaDocumentos, empresaDocumento, copia }) {
    const novoDoc = JSON.parse(JSON.stringify(empresaDocumento))
    novoDoc.customizado = true
    novoDoc.tags = []
    novoDoc.copia = copia
    // Quando o documento não é uma cópia o identificador ainda não foi alterado
    // para ser compativel com o EmpresaDocumento
    if (!copia) {
      novoDoc.documentoId = empresaDocumento.id
    }
    novoDoc.id = 0
    novoDoc.code = Date.now().toString(36) + Math.random().toString(36).substring(2)

    state_.ultimoDocumentoAtualizado = novoDoc
    Vue.set(empresaDocumentos, empresaDocumentos.length, novoDoc)
  },
  REMOVE_DOCUMENTO(state_, { empresaDocumentos, empresaDocumento }) {
    const indexDoc = empresaDocumentos
      .findIndex(f => (empresaDocumento.id && f.id === empresaDocumento.id)
        || (empresaDocumento.code && f.code === empresaDocumento.code))

    empresaDocumentos.splice(indexDoc, 1)
  },
  SELECIONAR_TODOS_DOCS_EMPRESA(state_, { departamentoIndex, selecionado }) {
    const filtered = state_.empresa.empresaDocumentos[departamentoIndex].documentos.filter(f => {
      state_.documentosAlterados.push(f)
      // Aqui eu comparo se é igual,
      // pois já foi feita uma alteração nas propriedades de selecionado
      if (f.vgtSelected === selecionado) {
        return !f.customizado
      }
      return true
    })
    Vue.set(state_.empresa.empresaDocumentos[departamentoIndex], 'documentos', filtered)
  },
  // MANIPULACAO DE TAGS
  ADD_TAG_DOCUMENTO(state_, { empresaDocumento, tag }) {
    Vue.set(tag, 'code', !tag.code ? Date.now().toString(36) + Math.random().toString(36).substring(2) : tag.code)
    if (!empresaDocumento.tags) {
      Vue.set(empresaDocumento, 'tags', [])
    }
    Vue.set(empresaDocumento.tags, empresaDocumento.tags.length, tag)
  },
  EDITAR_TAG_DOCUMENTO(state_, { empresaDocumento, tag }) {
    const index = empresaDocumento.tags.findIndex(i => (!tag.id && i.code === tag.code) || (tag.id && tag.id === i.id))
    Vue.set(empresaDocumento.tags, index, { ...tag })
  },
  REMOVE_TAG_DOCUMENTO(state_, { empresaDocumento, tag }) {
    const index = empresaDocumento.tags.findIndex(i => (tag.id && tag.id === i.id) || (tag.code && i.code === tag.code))
    empresaDocumento.tags.splice(index, 1)
  },
  ADD_TAG_DOCUMENTO_COBRANCA_MULTIPLA(state_, { empresaDocumento }) {
    Vue.set(empresaDocumento, 'multiplaCobranca', !empresaDocumento.multiplaCobranca)
    for (let i = 0; i < state_.empresa.contatos.length; i += 1) {
      const contato = state_.empresa.contatos[i]
      if (contato.documentos && contato.documentos.length > 0) {
        for (let j = 0; j < contato.documentos.length; j += 1) {
          const contatoDoc = contato.documentos[j]
          if (contatoDoc.documentos && contatoDoc.documentos.length > 0) {
            const index = contatoDoc.documentos.findIndex(f => (empresaDocumento.code && f.empresaDocumentoCode === empresaDocumento.code)
            || (empresaDocumento.id && f.empresaDocumentoId === empresaDocumento.id))
            if (index >= 0) {
              Vue.set(contatoDoc.documentos[index], 'multiplaCobranca', empresaDocumento.multiplaCobranca)
            }
          }
        }
      }
    }
  },
  // MANIPULACAO DE CONTATOS
  ADD_CONTATO(state_) {
    const novoContato = {
      code: Date.now().toString(36) + Math.random().toString(36).substring(2),
      receberEmail: true,
    }
    Vue.set(state_.empresa.contatos, state_.empresa.contatos.length, novoContato)
  },
  ADICIONA_DOCUMENTO_CONTATOS(state_, { departamento, customizado }) {
    const { contatos } = state_.empresa
    let jaExiste = false
    if (contatos != null && contatos.length > 0 && state_.ultimoDocumentoAtualizado) {
      for (let j = 0; j < contatos.length; j += 1) {
        // Precisa verficar se o contato possui um deprtamento para receber o novo departamento
        const contatoDocsPorDeparts = contatos[j].documentos
        // Caso não tenha um departamento, mas o usuário aceita receber, então temos que criar esta possibilidade
        if ((!contatoDocsPorDeparts || contatoDocsPorDeparts.length === 0 || contatoDocsPorDeparts.findIndex(f => f.departamento.id === departamento.id) < 0)
          && (contatos[j].departamentos && contatos[j].departamentos.length > 0
            && contatos[j].departamentos.findIndex(f => f.id === departamento.id) >= 0)) {
          contatos[j].documentos.push({
            departamento,
            documentos: [],
          })
        }

        if (contatoDocsPorDeparts && contatoDocsPorDeparts.length > 0) {
          for (let i = 0; i < contatos[j].documentos.length; i += 1) {
            const contatoDoc = contatos[j].documentos[i]
            // Vamos procurar para ver se já existe esse documento
            if (!customizado) {
              jaExiste = contatoDoc.documentos.findIndex(f => (state_.ultimoDocumentoAtualizado.code && f.empresaDocumentoCode === state_.ultimoDocumentoAtualizado.code)
                || (state_.ultimoDocumentoAtualizado.id && f.empresaDocumentoId === state_.ultimoDocumentoAtualizado.id))
                >= 0
              if (jaExiste) break
            }

            if (contatoDoc.departamento.id === departamento.id) {
              const contatoDocumento = { ...state_.ultimoDocumentoAtualizado }
              contatoDocumento.empresaDocumentoId = contatoDocumento.id
              contatoDocumento.empresaDocumentoCode = contatoDocumento.code
              contatoDocumento.id = 0
              contatoDocumento.code = Date.now().toString(36) + Math.random().toString(36).substring(2)
              contatoDocumento.customizado = customizado
              Vue.set(contatoDoc.documentos, contatoDoc.documentos.length, contatoDocumento)
              break
            }
          }
        }
        if (jaExiste) { break }
      }
    }
    state_.ultimoDocumentoAtualizado = null
  },
  REMOVER_DOCUMENTO_CONTATOS(state_, { departamento, removidoDaEmpresa = false }) {
    const { contatos } = state_.empresa

    if (contatos != null && state_.ultimoDocumentoAtualizado) {
      for (let j = 0; j < contatos.length; j += 1) {
        // Pega o agrupamento de documentos por departamento
        const contatoDepartamentos = contatos[j].documentos
        if (contatoDepartamentos !== undefined) {
          for (let i = 0; i < contatoDepartamentos.length; i += 1) {
            const departamentoDocs = contatoDepartamentos[i]
            if (departamentoDocs.departamento.id === departamento.id) {
              let index = -1
              if (!removidoDaEmpresa) {
                index = departamentoDocs.documentos
                  .findIndex(f => (state_.ultimoDocumentoAtualizado.id && f.id === state_.ultimoDocumentoAtualizado.id)
                    || (state_.ultimoDocumentoAtualizado.code && f.code === state_.ultimoDocumentoAtualizado.code))
              } else {
                index = departamentoDocs.documentos
                  .findIndex(f => (state_.ultimoDocumentoAtualizado.code && f.empresaDocumentoCode === state_.ultimoDocumentoAtualizado.code)
                    || (state_.ultimoDocumentoAtualizado.id && f.empresaDocumentoId === state_.ultimoDocumentoAtualizado.id))
              }
              departamentoDocs.documentos.splice(index, 1)
              break
            }
          }
        }
      }
    }
    state_.ultimoDocumentoAtualizado = null
  },
  // MANIPULAÇÃO DE RESPONSAVEIS POR DEPARTAMENTO
  ADD_RESPONSAVEIS_DEPARTAMENTO(state_) {
    const novoResponsaveisDepartamento = {
      code: Date.now().toString(36) + Math.random().toString(36).substring(2),
    }
    Vue.set(state_.empresa.departamentos, state_.empresa.departamentos.length, novoResponsaveisDepartamento)
  },
  SET_DADOS_INATIVAR(state_, { motivo, observacao }) {
    Vue.set(state_.empresa, 'motivoAtivaInativacao', motivo)
    Vue.set(state_.empresa, 'observarAtivarInativar', observacao)
  },
}

export default {
  namespaced: true,
  getters,
  actions,
  mutations,
  state: () => state,
}
